import { combineReducers } from 'redux';

import fo from './fo';
import group from './group';

export default combineReducers({ fo, group });
